import { APIService } from "@/services/APIService.inject";
import { LogInfoBase } from "@/services/Models";
import { AxiosResponse } from "axios";
import { inject, InjectionKey } from "vue";

const logger = (api: APIService) => {
  const log = async (x: LogInfoBase) => {
    await api.sendUserlog(x).catch((ex: AxiosResponse) => alert(ex.statusText));
  };
  return {
    log,
  };
};

export default logger;

export type Logger = ReturnType<typeof logger>;

export const LoggerKey: InjectionKey<Logger> = Symbol("Logger");

export const useLogger = () => {
  const store = inject(LoggerKey);
  if (!store) {
    throw new Error(`${LoggerKey} is not provided`);
  }
  return store;
};
